<template>
  <div>
    <img
      :src="featureImage ?? fallbackImage"
      :alt="title"
      :data-pin-description="description || title"
      :data-pin-url="featureImage"
      class="object-cover w-full h-full rounded-xl select-none aspect-21/9 shadow-2xl"
    >
  </div>
</template>

<script setup lang="ts">
defineProps<{
  featureImage: string
  title: string
  description?: Nullable<string>
}>()

const { getStaticImage } = useImage()
const fallbackImage = computed(() => getStaticImage({
  path: '/web-app/experience-blog/assets/images/group-with-campfire-westfalia_800x600.jpg',
}))
</script>
